module.exports = __webpack_public_path__ + "img/invoicelist-budget.d2ea0814.png";